import useGetAvatarNotesHistory from '@/hooks/useGetAvatarNotesHistory';
import Box from '@mui/material/Box';
import { nth } from 'lodash';
import { DateField, useTranslate } from 'react-admin';
import ExportLabelValue from '@/components/interventions/export-intervention/common/export-label-value';
import ExportSectionBox from '@/components/interventions/export-intervention/common/export-section-box';
import ShowNoteSignExportItem from '@/components/interventions/export-intervention/show-note-signs-export-item';

interface ExportInterventionSignaturesSectionProps {
    interventionId: string;
}

const ExportInterventionSignaturesSection = ({ interventionId }: ExportInterventionSignaturesSectionProps) => {
    const translate = useTranslate();

    const { history, isLoading: isLoadingHistory } = useGetAvatarNotesHistory({
        avatarId: interventionId,
    });

    const lastNote = nth(history, -1);

    if (isLoadingHistory || !lastNote || !lastNote.data?.signatures || lastNote.data.signatures.length === 0) {
        return null;
    }

    return (
        <ExportSectionBox title={translate('intervention.export.section.signatures')}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                }}
            >
                {lastNote.createdAt && (
                    <ExportLabelValue
                        label={translate('intervention.export.signatures.date')}
                        value={
                            <DateField
                                record={{
                                    date: lastNote.createdAt,
                                }}
                                options={{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }}
                                source={'date'}
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                }}
                            />
                        }
                    />
                )}

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: 2,
                    }}
                >
                    {lastNote.data.signatures.map((signature: any, index: number) => (
                        <ShowNoteSignExportItem
                            key={index}
                            imageDataBase64={signature.imageDataBase64}
                            name={signature.customFields.name}
                        />
                    ))}
                </Box>
            </Box>
        </ExportSectionBox>
    );
};

export default ExportInterventionSignaturesSection;
